
<ngx-loading [show]="loading" [config]="{fullScreenBackdrop : true}"></ngx-loading>


<div class="wsmenucontainer clearfix" style="margin-top: -10px !important;">
    <div id="overlapblackbg"></div>


    <div class="headerfull" id="wmsticky">
      <img src="assets/images/logo.png" class="sticylogo" id="sticylogo2"/>
      <div class="dropdown" style="    display: none !important; left:0px; z-index: 4000; height: 61px;  position: absolute; margin-right:100px;">
        <button class="dropbtn" id="sticky3" style="height: 61px;">
          <a  routerLink="/store/home" class="navtext">
            <span class="hovcolor"><i class="fas fa-cart-plus"></i>
              <span style="font-size: 20px;" class="hidden-sm-down">Store</span></span>
          </a>
        </button>


  <div class="dropdown-content" style="width: 100vw; ">

  <div class="wsmain" style="float:right; background-color:#dbd3be; z-index:10000;">

            <nav class="wsmenu clearfix" style="background-color:transparent !important; box-shadow:none; border:none;">
             <ul class="mobile-sub wsmenu-list">

               <li><a  style="z-index:5000;" class="navtext"><span></span> <span>Shop By Pet</span></a>
                 <div class="wsshoptabing wtsdepartmentmenu clearfix"  id="hidenav"  style ="position: absolute;
                width:1050px; height: 460px; z-index:5000;">
                   <div class="wsshopwp clearfix">
                     <ul class="wstabitem clearfix">
                       <li class="wsshoplink-active"><a routerLink="/store/products/1/dog-products.html">Dog</a>
                         <div class="wstitemright clearfix wstitemrightactive">
                           <div class="container-fluid">
                             <div class="row">
                               <div class="col-lg-8 col-md-12 clearfix">
                                 <div class="wstheading clearfix"><a routerLink="/store/products/5/dog-food.html">Dog Food</a></div>
                                 <ul class="wstliststy01 clearfix">
                                   <li><a routerLink="/store/products/15/dog-dry-food.html">Dry Food</a></li>
                                   <li><a routerLink="/store/products/16/dog-wet-food.html">Wet Food</a></li>
                                   <li><a routerLink="/store/products/17/dog-prescription-food.html">Prescription Food</a></li>

                                 </ul>

                                 <div class="wstheading clearfix"><a routerLink="/store/products/6/dog-treats.html">Dog Treats</a></div>
                                 <ul class="wstliststy01 clearfix">
                                   <li><a routerLink="/store/products/18/biscuits.html">Biscuits and Crunchy Treats</a></li>
                                    <li><a routerLink="/store/products/19/dental-treats.html">Dental Treats</a></li>
                                     <li><a routerLink="/store/products/20/soft-treats.html">Soft and Chewy Treats</a></li>
                                      <li><a routerLink="/store/products/21/jerky-treats.html">Jerky Treats</a></li>
                                        <li><a routerLink="/store/products/22/natural-treats.html">Natural Chews</a></li>

                                 </ul>

                                 <div class="wstheading clearfix"><a routerLink="/store/products/7/dog-supplies.html">Supplies</a></div>
                                 <ul class="wstliststy01 clearfix">
                                   <li><a routerLink="/store/products/23/dog-toys.html">Toys</a></li>
                                     <li><a routerLink="/store/products/25/dog-grooming.html">Grooming</a></li>
                                       <li><a routerLink="/store/products/26/dog-cleaning.html">Cleaning</a></li>
                                   <li><a routerLink="/store/products/30/bowls.html">Bowls and Feaders</a></li>
                                   <li><a routerLink="/store/products/24/dog-healthcare.html">Health Care</a></li>
                                    <li><a routerLink="/store/products/29/fashion.html">Costumes and Fashion</a></li>
                                     <li><a routerLink="/store/products/28/accessories.html">Accessories</a></li>
                                      <li><a routerLink="/store/products/27/beds.html">Beds and Mats</a></li>





                                 </ul>



                               </div>

                                <div class="col-lg-4 col-md-12 clearfix"><a class="wstmegamenucolr"><img src="assets/images/dogmenu.jpg" alt="" ></a></div>

                             </div>
                           </div>
                         </div>
                       </li>




                       <li><a routerLink="/store/products/2/catproducts.html">Cat</a>
                         <div class="wstitemright clearfix">
                           <div class="container-fluid">
                             <div class="row">
                               <div class="col-lg-8 col-md-12 clearfix">
                                 <div class="wstheading clearfix"><a routerLink="/store/products/8/cat-food.html">Cat Food</a></div>
                                 <ul class="wstliststy01 clearfix">
                                   <li><a routerLink="/store/products/31/cat-dry-food.html">Dry Food</a></li>
                                   <li><a routerLink="/store/products/32/cat-wet-food.html">Wet Food</a></li>
                                   <li><a routerLink="/store/products/33/cat-prescription-food.html">Prescription Food</a></li>


                                 </ul>



                                 <div class="wstheading clearfix"><a routerLink="/store/products/9/cat-treats.html">Cat Treats</a></div>
                                 <ul class="wstliststy01 clearfix">
                                   <li><a routerLink="/store/products/34/biscuits.html">Biscuits and Crunchy Treats</a></li>
                                    <li><a routerLink="/store/products/35/dental-treats.html">Dental Treats</a></li>
                                     <li><a routerLink="/store/products/36/soft-treats.html">Soft and Chewy Treats</a></li>
                                      <li><a routerLink="/store/products/37/jerky-treats.html">Jerky Treats</a></li>

                                 </ul>

                                 <div class="wstheading clearfix"><a routerLink="/store/products/10/cat-litter.html">Cat Litter and Accessories</a></div>
                                 <ul class="wstliststy01 clearfix">
                                   <li><a routerLink="/store/products/38/litter.html">Cat Litter</a></li>
                                    <li><a routerLink="/store/products/39/litter-tray.html">Litter Trays</a></li>
                                     <li><a routerLink="/store/products/40/waste-disposal.html">Waste Disposal</a></li>
                                      <li><a routerLink="/store/products/41/cleaners.html">Cleaners and Deodorizers</a></li>

                                 </ul>

                                 <div class="wstheading clearfix"><a routerLink="/store/products/11/cat-supplies.html">Supplies</a></div>
                                 <ul class="wstliststy01 clearfix">
                                   <li><a routerLink="/store/products/47/cat-toys.html">Toys</a></li>
                                     <li><a routerLink="/store/products/45/cat-grooming.html">Grooming</a></li>
                                       <li><a routerLink="/store/products/43/cat-cleaning.html">Cleaning</a></li>
                                   <li><a routerLink="/store/products/46/cat-healthcare.html">Health Care</a></li>
                                    <li><a routerLink="/store/products/44/fashion.html">Costumes and Fashion</a></li>
                                     <li><a routerLink="/store/products/42/accessories.html">Accessories</a></li>


                                 </ul>







                               </div>
                               <div class="col-lg-4 col-md-12 clearfix"><a class="wstmegamenucolr"><img src="assets/images/catmenu.jpg" alt="" ></a></div>
                             </div>
                           </div>
                         </div>
                       </li>



                     </ul>
                   </div>
                 </div>
               </li>
                 <li><a  style="z-index:5000;" class="navtext"><span></span> <span>Shop By Brand</span></a>
                    <div class="megamenu clearfix"  id="hidenav2" style ="position: absolute;
                    width:1050px; height: 460px; z-index:5000;  background-color: #f7f4ea;
                      color: #9b7544;box-shadow: 0 1px 4px rgba(0, 0, 0, .5);font-size: 2em;">
                      <div class="container-fluid">
                        <div class="row">
                          <div class="col-lg-3 col-md-12">
                            <ul class="wstliststy02 clearfix">

                                <li class="wstheading clearfix"> A-C </li>
                                    <li><a routerLink="/store/search/brand/10">Arden Grange</a></li>
                                    <li><a routerLink="/store/search/brand/11">Aroma Tree</a></li>
                                    <li><a routerLink="/store/search/brand/13">Bayer</a></li>
                                    <li><a routerLink="/store/search/brand/14">Beaphar</a></li>
                                    <li><a routerLink="/store/search/brand/15">Bellotta</a></li>
                                    <li><a routerLink="/store/search/brand/18">BI</a></li>
                                    <li><a routerLink="/store/search/brand/20">Bio-Groom</a></li>
                                    <li><a routerLink="/store/search/brand/21">Canine Creek</a></li>
                                    <li><a routerLink="/store/search/brand/119">Capt Zack</a></li>
                                    <li><a routerLink="/store/search/brand/23">Cat Exclusive</a></li>
                                    <li><a routerLink="/store/search/brand/25">Cataholic</a></li>
                                    <li><a routerLink="/store/search/brand/24">Cats Best</a></li>
                                    <li><a routerLink="/store/search/brand/26">Chappi</a></li>
                                    <li><a routerLink="/store/search/brand/29">Chip Chops</a></li>
                                    <li><a routerLink="/store/search/brand/31">Choostix</a></li>
                            </ul>
                          </div>
                          <div class="col-lg-3 col-md-12">
                            <ul class="wstliststy02 clearfix">
                              <li class="wstheading clearfix">D-L</li>
                                  <li><a routerLink="/store/search/brand/35">Delite</a></li>
                                  <li><a routerLink="/store/search/brand/36">Dogaholic</a></li>
                                  <li><a routerLink="/store/search/brand/37">Doggy Dolly</a></li>
                                  <li><a routerLink="/store/search/brand/41">Drools</a></li>
                                  <li><a routerLink="/store/search/brand/45">Fidele</a></li>
                                  <li><a routerLink="/store/search/brand/52">Gnawlers</a></li>
                                  <li><a routerLink="/store/search/brand/54">GoodieS</a></li>
                                  <li><a routerLink="/store/search/brand/56">Happy Cat</a></li>
                                  <li><a routerLink="/store/search/brand/59">Hills</a></li>
                                  <li><a routerLink="/store/search/brand/60">Himalaya</a></li>
                                  <li><a routerLink="/store/search/brand/64">JerHigh</a></li>
                                  <li><a routerLink="/store/search/brand/65">Jinny</a></li>
                                  <li><a routerLink="/store/search/brand/67">Kennel Kitchen</a></li>
                                  <li><a routerLink="/store/search/brand/4">Lets Bite</a></li>
                            </ul>
                          </div>
                          <div class="col-lg-3 col-md-12">
                            <ul class="wstliststy02 clearfix">
                              <li class="wstheading clearfix">M-T</li>
                                    <li><a routerLink="/store/search/brand/70">Me-O</a></li>
                                    <li><a routerLink="/store/search/brand/72">mybeau</a></li>
                                    <li><a routerLink="/store/search/brand/80">Others</a></li>
                                    <li><a routerLink="/store/search/brand/81">Pedigree</a></li>
                                    <li><a routerLink="/store/search/brand/86">Petkin</a></li>
                                    <li><a routerLink="/store/search/brand/90">Purepet</a></li>
                                    <li><a routerLink="/store/search/brand/1">Royal Canin</a></li>
                                    <li><a routerLink="/store/search/brand/94">Savic</a></li>
                                    <li><a routerLink="/store/search/brand/96">Sheba</a></li>
                                    <li><a routerLink="/store/search/brand/97">Simple Solution</a></li>
                                    <li><a routerLink="/store/search/brand/98">Smart Heart</a></li>
                                    <li><a routerLink="/store/search/brand/101">Standard</a></li>
                                    <li><a routerLink="/store/search/brand/105">Trixie</a></li>
                                    <li><a routerLink="/store/search/brand/106">Twistix</a></li>
                            </ul>
                          </div>
                          <div class="col-lg-3 col-md-12">
                            <ul class="wstliststy02 clearfix">
                              <li class="wstheading clearfix">U-Z</li>
                                      <li><a routerLink="/store/search/brand/109">Versele Laga</a></li>
                                      <li><a routerLink="/store/search/brand/111">Virbac</a></li>
                                      <li><a routerLink="/store/search/brand/112">Vitapol</a></li>
                                      <li><a routerLink="/store/search/brand/113">WAHL</a></li>
                                      <li><a routerLink="/store/search/brand/114">Whiskas</a></li>

                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>


             </ul>
           </nav>

          </div>
      </div>
    </div>


   <div class="dropdown" style="z-index: 4000;     height: 61px;  position: absolute; margin: 0 0 0 230px;">
      <button class="dropbtn" style="    height: 61px;">
        <a  routerLink="/pulse/home" class="navtext">
          <span class="hovcolor">
            <span style="font-size: 20px;" class="hidden-sm-down">Connect with a Vet</span></span>
        </a>
      </button>


      <div class="dropdown-content">

            <ul class="pulsemenu2">
              <li><a routerLink="/pulse/doctor">Appointment with a Vet</a></li>
              <li><a routerLink="/pulse/onlinedoctors">Chat with a Vet</a></li>

            </ul>

      </div>
    </div>


    <div class="dropdown" style="z-index: 4000;     height: 61px;  position: absolute; margin: 0 0 0 450px;">
       <button class="dropbtn" style="    height: 61px;">
         <a  routerLink="/pulse/home" class="navtext">
           <span class="hovcolor">
             <span style="font-size: 20px;" class="hidden-sm-down">Services</span></span>
         </a>
       </button>


       <div class="dropdown-content">

             <ul class="pulsemenu2">
               <li><a routerLink="/pulse/setreminder">Set Reminders</a></li>
               <li><a routerLink="/manageprofile/manageyourpet">Scan Records</a> </li>
            <!--   <li><a routerLink="/pulse/doctor">Know Yourself</a></li>
               <li><a routerLink="/vets">For Vets</a></li>-->
             </ul>

       </div>
     </div>






<div class="wsmain" id="menub" style="margin-top: -24px">

            <nav class="wsmenu clearfix">
            <!-- <ul class="mobile-sub wsmenu-list">
               <li *ngIf="special.length>0 && menuflagstatus ==1" style="margin-top: 20px; float: right;">
                  <md-select placeholder=" Select Specialisation"  [(ngModel)]="speci"  (change)="UpdateFilter($event)">
                      <md-option *ngFor="let data of special" [value]="data.id">{{ data.name }}</md-option>
                    </md-select>
               </li>
               <li class="wssearchbar clearfix" style=" float: right;"
               *ngIf="menuflagstatus ==1">

                  <div class="topmenusearch"  *ngIf="menuflagstatus ==1">
                      <input  type="text" name="location" [(ngModel)]="currentlocationString"
                      placeholder="Select Your Current Location"
                      autocorrect="off" autocapitalize="off" spellcheck="off" type="text" class="form-control"
                      #search/>
                    <button  (click)='getLocation()' class="btnstyle">
                      <i class="fas fa-map-marker-alt" aria-hidden="true" style="color: #fff;"></i></button>
                  </div>
               </li>

             </ul>-->
           </nav>

          </div>

        </div>
      </div>


       <!--   <ng-template #rt let-r="result" let-t="term" style="height:500px">
              <div (click)="goToDetail(r.type_id,r.url,r.type)">
                <span style="font-size:12px; font-weight:bold;">{{ r.title}}</span>
              </div>
              </ng-template> -->
